import { BackendHttpService } from "./backendHttpService";

export class EuropassService extends BackendHttpService {
    constructor() {
        super("Europass");
    }

    async exportToPdf(userId: number, language: string = 'None'): Promise<Blob> {
        try {
            const targetLanguageParam = language !== 'None' ? `?targetLanguage=${language}` : '';
            const response = await fetch(
                this.buildUrl(`${userId}/ToEuropassPdf${targetLanguageParam}`),
                {
                    method: "GET",
                    headers: await this.getAuthHeaders(),
                }
            );

            if (!response.ok) {
                let errorMessage = `Failed to export CV as Europass PDF`;
                try {
                    const errorText = await response.text();
                    if (errorText) {
                        const errorData = JSON.parse(errorText);
                        errorMessage = errorData.Error || errorData.error || errorText;
                    }
                } catch {
                    errorMessage = `HTTP error! Status: ${response.status} ${response.statusText}`;
                }
                throw new Error(errorMessage);
            }

            const blob = await response.blob();

            if (blob.type === 'application/json') {
                const text = await blob.text();
                try {
                    const errorData = JSON.parse(text);
                    throw new Error(errorData.message || errorData.error || 'Failed to export Europass CV');
                } catch {
                    throw new Error('Server returned an error response');
                }
            }

            return blob;
        } catch (error) {
            console.error("Error exporting to Europass PDF:", error);
            if (error instanceof Error) {
                throw error;
            }
            throw new Error("Failed to export CV as Europass PDF. Please try again.");
        }
    }

    private async getAuthHeaders(): Promise<HeadersInit> {
        const accessToken = await this.getAccessToken();

        return {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
        };
    }
}

